import React, { useState, useEffect } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import apiService from '../../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import MenuVerDiagnosticos from './MenuVerDiagnosticos';
import ButtonsMenu from '../../Utils/ButtonsMenu';
import { useAuth } from '../../../Auth/AuthContext';
import { BotonVerAtencionesPersona } from '../../Utils/BotonVerAtencionesPersona';

export default function DiagUnidadFamiliar(){
    const { token } = useAuth();
    const navigate = useNavigate();
    const [Cargando, setCargando] = useState(false);
    const [datosUnidadFamiliar, setDatosUnidadFamiliar] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10); 
    const [swalProps, setSwalProps] = useState();
    useEffect(() => {
        fetchData(currentPage, perPage);
    }, [currentPage, perPage]);
    const fetchData = async (page, rowsPerPage) => {
        const url = `/caracterizacion/diagnosticos/listardatounidadfamiliar?page=${page}&limit=${rowsPerPage}`;
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            setDatosUnidadFamiliar(result.data);
            setTotalRows(result.meta.total);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
        
        
    };
    function verAtencionPersona (row){
                return <BotonVerAtencionesPersona verAtencionesPersona={verAtencionesPersona} id={row.idpersona} row={row} />
            }
    const columns = [
            {
                name: 'Acciones',
                cell: row => verAtencionPersona(row),
                ignoreRowClick: true,
                width: '3%'
            },
        { name: 'Identificación Cabeza', selector: row => row.idpersona, sortable: true, width:'11%' },
        { name: 'Nombre', selector: row => row.nombre, sortable: true, width: '20%'},
        { name: '¿Cuando la familia se desplazó tuvo que separarse?', selector: row => row.uni_tuvosepararse, sortable: true, width: '15%'},
        { name: '¿Qué miembros de la familia se separaron?', selector: row => row.parentesco, sortable: true, width: '20%' },
        { name: '¿La familia desea que los miembros que se separaron vuelvan?', selector: row => row.uni_deseamiembrosvuelvan, sortable: true, width: '10%' },
        { name: '¿La familia ha solicitado ayuda del Estado para la reunificación familiar?', selector: row => row.uni_solayudareunificacion, sortable: true, width: '10%' },
        { name: '¿La ha recibido?', selector: row => row.uni_harecibidoayuda_reuni, sortable: true, width: '10%' }
    ];
    function verAtencionesPersona (row){
        navigate(`/consulta/consultaatenciones/${row.idpersona}`);
    };
    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
        fetchData(page, newPerPage);
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, perPage);
      };
    async function exportarCSV() {
        setCargando(true);
        const url = `/caracterizacion/diagnosticos/listardatounidadfamiliar?page=0&limit=0&csv=true`;

        try {
            const response = await apiService.get(url, token, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', 'datos_unidad_familiar.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Diagnostico unidad familiar</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to="/" >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to="/consultas/verdiagnosticos" >Diagnosticos</NavLink></li>
                        <li className="breadcrumb-item active"> Unidad familiar</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuVerDiagnosticos />
                    <div className="row">
                        <div className="col-md-12">
                            <ButtonsMenu data={datosUnidadFamiliar} titulo={'Informe Datos Unidad Familiar'} exportarCSV={exportarCSV} />
                            <div className="card-body table-responsive p-0">
                                <DataTable
                                    title="Unidad familiar"
                                    columns={columns}
                                    data={datosUnidadFamiliar}
                                    progressPending={Cargando}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    paginationPerPage={perPage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}